import React from 'react';
import { TextField, MenuItem, Select, FormControl, SelectChangeEvent, Grid } from '@mui/material';
import { Field, FieldInputProps, FieldMetaProps, FormikProps } from 'formik';
import { Identity } from '../../types/identity';
import { AVAILABLE_LANGUAGES } from '../../types/languages';

interface LanguageFieldProps {
  id: string;
  editModeEnabled: boolean;
  formikProps: FormikProps<Required<Identity>>;
}

export const LanguageField: React.FC<LanguageFieldProps> = ({
  id,
  editModeEnabled,
  formikProps,
}) => {
  const handleChange = (event: SelectChangeEvent<string>) => {
    const { setFieldValue } = formikProps;
    setFieldValue('language', event.target.value);
  };

  return (
    <Grid item xs={8}>
      <Field name="language">
        {({ field }: { field: FieldInputProps<string>; meta: FieldMetaProps<string> }) => (
          <FormControl id={id} variant="outlined" size="small" fullWidth>
            {editModeEnabled ? (
              <Select value={field.value} onChange={handleChange} size="small">
                {AVAILABLE_LANGUAGES.map((langCode) => (
                  <MenuItem id={langCode} key={langCode} value={langCode}>
                    {langCode}
                  </MenuItem>
                ))}
              </Select>
            ) : (
              <TextField
                id={id}
                variant="outlined"
                size="small"
                className="white_outlined"
                fullWidth
                required={false}
                label={null}
                disabled
                value={field.value}
                inputProps={{ 'aria-label': 'Language' }}
                InputLabelProps={{ shrink: false }}
              />
            )}
          </FormControl>
        )}
      </Field>
    </Grid>
  );
};

export default LanguageField;
